<template>
  <div>
    <div
      v-if="
        typeof error_messages === 'object' &&
          Object.keys(error_messages).length > 0
      "
      class="alert alert-danger"
    >
      <ul>
        <template v-for="(error, i) in error_messages">
          <span v-bind:key="i">
            <li v-for="(message, ii) in error" v-bind:key="ii">
              {{ message }}
            </li>
          </span>
        </template>
      </ul>
    </div>
    <div class="tabs">
      <v-tabs
        v-model="tab"
        background-color="light primary"
        class="elevation-2"
        dark
      >
        <v-tab>{{ $t("CLIENT") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <vue-form-generator
                ref="form"
                :schema="clientSchema"
                :model="client"
                :options="formOptions"
              ></vue-form-generator>

              <v-btn
                @click="save()"
                class="btn btn-success btn-elevate kt-login__btn-primary text-white"
                >{{ $t("SAVE") }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css"; // optional full css additions

import { GET_CLIENT, SAVE_CLIENT, UPDATE_CLIENT } from "@/store/clients.module";

import { mapGetters, mapState } from "vuex";
// Vue.use(VueFormGenerator)

import _ from "lodash";

export default {
  name: "createUpdate",

  components: {
    "vue-form-generator": VueFormGenerator.component
  },
  computed: {
    ...mapGetters(["isLoadingClients"]),
    ...mapState({
      errors: state => state.auth.errors
    })
  },
  data() {
    return {
      error_messages: [],
      model: "clients",
      tab: 0,
      clientFormula: {},
      rawClients: [],
      client: {
        name: null
      },
      clientSchema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("NAME") + " (BG)",
            model: "name",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("NAME") + " (EN)",
            model: "name_en",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("EIK"),
            model: "eik",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("MATERIALLY_RESPONSIBLE_PERSON") + " (BG)",
            model: "mol",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("MATERIALLY_RESPONSIBLE_PERSON") + " (EN)",
            model: "mol_en",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("NUMBER_BY_VAT"),
            model: "vat",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("BANK") + " (BG)",
            model: "bank",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("BANK") + " (EN)",
            model: "bank_en",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: "IBAN",
            model: "iban",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("CONTACT") + " (BG)",
            model: "contact",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("CONTACT") + " (EN)",
            model: "contact_en",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("COUNTRY") + " (BG)",
            model: "country",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("COUNTRY") + " (EN)",
            model: "country_en",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("CITY") + " (BG)",
            model: "city",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("CITY") + " (EN)",
            model: "city_en",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("ADDRESS") + " (BG)",
            model: "address",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("ADDRESS") + " (EN)",
            model: "address_en",
            required: true,
            styleClasses: "col-md-6",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false,
        validateAsync: true
      }
    };
  },
  mounted() {
    let vm = this;

    _.delay(function() {
      var current_page = vm.$t("ADD");
      if (typeof vm.$route.params.id !== "undefined") {
        current_page = vm.$t("MODIFY");
      }
      vm.$store.dispatch(SET_BREADCRUMB, [
        { title: vm.$t("CLIENTS"), route: "/clients" },
        { title: current_page }
      ]);
    }, 300);

    if (typeof this.$route.params.id !== "undefined") {
      this.getData();
    }
  },
  methods: {
    async save() {
      let vm = this;

      vm.error_messages = [];

      let errors = await this.$refs.form.validate();

      if (errors.length) {
        return;
      }

      var action =
        typeof this.$route.params.id !== "undefined"
          ? UPDATE_CLIENT
          : SAVE_CLIENT;

      vm.$store
        .dispatch(action, { payload: vm.client })
        .then(data => {
          vm.$notification["success"]({
            message: data.status,
            description: data.message
          });

          vm.$router.push({ name: "clientsList" });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });

          if (response.status === 404) {
            vm.$notification["success"]({
              message: response.status,
              description: response.message
            });
            vm.$router.push({ name: "clientsList" });
          }
        });
    },
    getData: function() {
      let vm = this;
      this.error_messages = [];
      let id = this.$route.params.id;
      this.$store
        .dispatch(GET_CLIENT, id)
        .then(data => {
          vm.$nextTick(function() {
            vm.client = data.data;
          });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });

          if (typeof response === "undefined" || response.status === 404) {
            vm.$notification["error"]({
              message: vm.$t("ERROR") + " 404",
              description: vm.$t("PAGE_NOT_FOUND")
            });
            vm.$router.push({ name: "clientsList" });
          }
        });
    }
  }
};
</script>
